import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { QueryProvider } from './app/providers/QueryProvider';
import { AuthInitializer } from '@/features/auth/AuthInitializer';
import { ThemeProvider } from './theme/ThemeProvider';
import AppRouter from './AppRouter';
import './participantUiBootstrap';
import { purgeLegacyStoredRuns } from '@/app/persistence/lastSession';
import { ViewportDebugOverlay } from '@/features/dev/ViewportDebugOverlay';
import 'pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css';
import './theme/global.css';
import './theme/tokens.css';
import './shared/ui/resizePanels.css';

// 폐지된 실행 스냅샷(vsmr.lastRun.*) 잔존 키 청소 — 복귀 개념 폐지(2026-08-08)
purgeLegacyStoredRuns();


// 재배포 후 스테일 탭 복구 — 열린 탭이 구버전 index.html의 해시로 지연 청크를
// 요청하면 404(Failed to fetch dynamically imported module). 새 버전 로드를 위해
// 1회만 자동 리로드(무한 루프 방지: sessionStorage 가드, 정상 로드 시 해제).
// 지연 청크는 라우트 단위라 이 재로드는 언제나 사용자가 가려던 목적지 라우트에서 일어난다 — 실행 화면에
// 있는 동안은 재로드가 없고, 떠났다 돌아오는 길은 설계대로 [이어보기]다(«진입 = 새 시작»).
window.addEventListener('vite:preloadError', (event) => {
  const GUARD_KEY = 'vsmr-chunk-reload';
  if (sessionStorage.getItem(GUARD_KEY)) {
    return; // 리로드 후에도 실패 — 진짜 서버 문제이므로 원래 오류를 흘려보낸다
  }
  sessionStorage.setItem(GUARD_KEY, '1');
  event.preventDefault();
  window.location.reload();
});
window.addEventListener('load', () => sessionStorage.removeItem('vsmr-chunk-reload'));

// Dev-only: expose useStore on window for DevTools Console debugging
// (e.g., `useStore.getState().restartBaseline` to inspect diff state manually)
if (import.meta.env.DEV) {
  // 편집기 스토어는 진입 청크 밖(트랙 A-4) — 디버그 노출도 지연 적재
  void import('@/app/stores/useStore').then(({ useStore }) => { (window as unknown as { useStore: typeof useStore }).useStore = useStore; });
  // Edge validation diagnostic — `window.__validateEdges()` to compare from/to ↔ actual edges
  void import('@/features/dev/validateEdges').then(({ exposeValidateEdges }) => exposeValidateEdges());
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryProvider>
      <ThemeProvider>
        <AuthInitializer>
          <AppRouter />
        </AuthInitializer>
        {import.meta.env.DEV && <ViewportDebugOverlay />}
        <Toaster
          position="top-right"
          containerStyle={{
            top: '80px',
          }}
          toastOptions={{
            duration: 4000,
            style: {
              background: 'var(--toast-bg)',
              color: 'var(--toast-text)',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: 'var(--state-ok)',
                secondary: 'var(--toast-text)',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: 'var(--state-alarm)',
                secondary: 'var(--toast-text)',
              },
            },
          }}
        />
      </ThemeProvider>
    </QueryProvider>
  </StrictMode>,
);

